export enum DismissPayloadType {
    LOGOUT = 'logout',
    OB_COMPLETE = 'onboardingComplete',
}
